import ODAS from '@/utils/api/odas';

const Notification = {
  getGlobalAlerts: (params) => {
    return ODAS.get('/api/alert', params);
  }
};

export default Notification;
